import { useSelector } from 'react-redux';
import { RootState, store } from 'src/redux/store';
import { setSiteAuditDetails, setSiteStatus } from 'src/redux/siteAuditReducer';
import Intercom from 'react-intercom';
import { INTERCOM_APP_ID } from 'src/appConfig';
import { getLogout } from '../Scraper';
import { removeUtmCookie } from './FunctionHelperPartTwo';
import {
  AFFILIATE_COOKIE_NAME,
  isLoginOrSignup,
  localseoSignup,
  localseoSignupSqspFlow,
  localSeoUpgradeCTAText,
  planNameCookie,
  SEO_AFFILIATE_COOKIE_NAME,
  squareSpaceUtm
} from './TextMessage';
import { jwtDecrypt } from 'jose';
import jwt_decode from 'jwt-decode';
import axios from 'axios';
import { Plans } from 'src/types/plan.types';
import { posthogService, PostHogEvent } from '../services/posthogService';
/**
 * Set user token cookie
 *
 * @param authToken for token
 * @param checkDetail for user custom token details, if passed false then stop the call
 */
export function setCookie(token: string, username: string) {
  removeCookie();
  const expTime = getExpTime();
  const cookieString = `${process.env.REACT_APP_COOKIE_NAME}=${token};expires=${expTime};path=/;secure=true;`;
  document.cookie = cookieString;
  localStorage.setItem('isAuthenticated', 'true');
  localStorage.setItem('userName', username);
}
/**
 * Set user token cookie
 *
 * @param authToken for token
 * @param checkDetail for user custom token details, if passed false then stop the call
 */
export function removeCookie() {
  // const expTime = getExpTime();
  // const cookieString = `RoughWaterUserLogging=false;expires=${expTime};path=/;secure=true;`;
  // document.cookie = cookieString;
  document.cookie = `${process.env.REACT_APP_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; Secure; SameSite=Lax`;
  document.cookie = `${process.env.REACT_APP_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.seospace.co; Secure; SameSite=Lax`;
  localStorage.setItem('isAuthenticated', 'false');
  localStorage.setItem('userName', '');
}

/**
 * Get cookie details
 *
 * @param name for cookie name
 *
 * @returns
 */
export function getCookie(name: string) {
  const value: any = `; ${document.cookie}`;
  const parts: any = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/**
 * Set value in local storage
 *
 * @param authToken for user auth token
 */
export async function setLocalStorage(authToken: string) {
  if (authToken) {
    let decoded: any = await getTokenDetails(authToken);
    if (decoded.user_details) {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userName', decoded.user_details.email);
    }
  } else {
    localStorage.setItem('isAuthenticated', 'false');
    localStorage.setItem('userName', '');
  }
}
export function getAuthenticated() {
  return localStorage.getItem('isAuthenticated');
}

export function setGetUserName(
  email: string = '',
  isSetOrGet: boolean = false
) {
  if (isSetOrGet) {
    localStorage.setItem('userName', email);
  } else {
    return localStorage.getItem('userName');
  }
}

/**
 * Get token details
 *
 * @param token for user Authenticated token
 *
 * @returns
 */
export const getTokenDetails = async (token: string) => {
  let userToken: any = {};
  try {
    if (token.indexOf('&') > -1) {
      const customToken = token.split('&')[0];
      const authToken = token.split('&')[1];
      userToken = {
        user_details: await decryptEncryptedJWT(authToken),
        // user_details: jwt_decode(authToken),
        auth_token: authToken,
        custom_token: customToken,
        custom_details: await decryptEncryptedJWT(customToken)
        // custom_details: jwt_decode(customToken)
      };
    } else {
      userToken = {
        user_details: await decryptEncryptedJWT(token),
        // user_details: jwt_decode(token),
        auth_token: token,
        custom_token: '',
        custom_details: ''
      };
    }
  } catch (e) {
    userToken = {
      user_details: '',
      auth_token: '',
      custom_token: '',
      custom_details: ''
    };
  }
  return userToken;
};

export const timeConverter = (
  UNIX_timestamp: number,
  dateFormat: string,
  isNoTime = false,
  isNoYear = false,
  showComa = false
) => {
  if (!UNIX_timestamp) {
    return '';
  }

  const convertDateTime = new Date(UNIX_timestamp);
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const year = convertDateTime.getFullYear();
  const month = months[convertDateTime.getMonth()];
  const date = convertDateTime.getDate();
  let time = '';

  // ✅ Formatting the date based on the specified format & isNoYear
  if (dateFormat === 'DD/MM/YYYY') {
    time = isNoYear
      ? `${date} ${month}`
      : showComa
      ? `${date} ${month}, ${year}`
      : `${date} ${month} ${year}`;
  } else if (dateFormat === 'MM/DD/YYYY') {
    time = isNoYear
      ? `${month} ${date}`
      : showComa
      ? `${month} ${date}, ${year}`
      : `${month} ${date} ${year}`;
  }

  // ✅ If isNoTime is false, append the time
  if (!isNoTime) {
    const formattedTime = convertDateTime.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
    time += `, ${formattedTime}`;
  }

  return time;
};

export const parseAsLocalDate = (val: number | string | undefined | null) => {
  if (!val) return new Date(0);
  const num = Number(val);
  const d = new Date(num > 10000000000 ? num : num * 1000);
  if (isNaN(d.getTime())) return new Date(0);
  // Create a local date at midnight that matches the UTC year/month/day
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

/**
 * Format a timestamp to a readable date format.
 *
 * @param {number} timestamp - The timestamp to format.
 * @returns {string} - The formatted date in the "dd/mm/yyyy" format.
 */

export const formatTimestamp = (timestamp, dateFormat) => {
  const date = new Date(timestamp);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  // Formatting the date based on the specified format
  let formattedDate;
  if (dateFormat == 'DD/MM/YYYY') {
    formattedDate = `${day}/${month}/${year}`;
  } else if (dateFormat == 'MM/DD/YYYY') {
    formattedDate = `${month}/${day}/${year}`;
  }
  return formattedDate;
};

/**
 * Url sanitize
 *
 * @param url for token
 */
export const sanitizeURL = (url: string) => {
  let formateURL = url?.replace(/www./g, '');
  return formateURL;
};

export const removeHostname = (site: string) => {
  const fixedUrl = site?.startsWith('http') ? site : `https://${site}`;
  // Create a new URL object
  const parsedUrl = new URL(fixedUrl);
  // Extract only the pathname
  const pathname = parsedUrl?.pathname;
  return pathname === '/' || pathname === '' ? '/' : pathname;
};

/**
 * First Letter of Name
 *
 * @param url for token
 */
export const firstLetterName = (url: string) => {
  try {
    let formateURL = url
      ?.match(/(^|\s)[A-z a-z]/g)
      .join('')
      .replace(/ /g, '')
      .substring(0, 2);
    return formateURL;
  } catch (e) {
    return url;
  }
};

/**
 * Redirect to new Url
 *
 * @param url for new window
 *
 * @param scanID for new scan id
 */
export const openSite = (url: string = '', scanID: Array<string> = []) => {
  // Ensure URL is valid
  if (!url) {
    console.error('Invalid URL passed to openSite');
    return;
  }
  if (document.querySelector('#rough-water-seo-root')) {
    try {
      window.postMessage(
        {
          message: 'open_new_tab',
          value: { url: url, id: scanID, isSquareSpace: false }
        },
        '*'
      );
    } catch (error) {
      console.error('Error in window.postMessage:', error);
    }
  } else {
    try {
      window.open(url, '_blank');
    } catch (error) {
      console.error('Error opening new tab:', error);
    }
  }
};

/**
 * Open squerspace editor Redirect to new Url
 *
 * @param url for new window
 *
 * @param scanID for new scan id
 */
export const openSquareSpaceEditor = (
  url: string,
  scanUrl: string,
  scanID: Array<string> = []
) => {
  if (document.querySelector('#rough-water-seo-root')) {
    window.postMessage(
      {
        message: 'open_new_tab',
        value: { url: url, id: scanID, scanUrl: scanUrl, isSquareSpace: true }
      },
      '*'
    );
  } else {
    window.open(url, '_blank');
  }
};

/**
 * Redirect to progress color
 *
 * @param url for percentage
 */
export const getProgressColor = (progress = 0) => {
  if (progress <= 33) {
    return 'secondary';
  } else if (progress > 33 && progress < 66) {
    return 'info';
  } else {
    return 'error';
  }
};

/**
 * setting progess score calculation
 *
 * @param url for percentage
 */
export const setProgressCalculation = (userDetailsResponse, addOnDetails) => {
  const state = store.getState();
  const user = state.user;
  let scan = Number(user?.subscription?.plan_name?.scan);
  let useScan = Number(userDetailsResponse?.subscription?.used_scan);
  if (addOnDetails) {
    addOnDetails.map((data, index) => {
      if (data.used_scan !== undefined && data.scan !== undefined) {
        useScan += Number(data.used_scan);
        scan += Number(data.scan);
      }
    });
  }
  return { useScan, scan };
};

/**
 * Redirect to new tab Url
 *
 * @param url for new window
 */
export const openNewTab = (url: string) => {
  window.open(url, '_blank');
};

/**
 * Normalizes a name by converting to lowercase and stripping all whitespaces.
 * 
 * @param {string} name Raw name
 * @returns {string} Normalized name
 */
export const normalizeName = (name: string) => {
  return name ? name.toLowerCase().replace(/\s+/g, '') : '';
};


/**
 * Redirect to new tab Url
 *
 * @param url for new window
 */
export const openLeadUrl = (url: string) => {
  if (document.querySelector('#rough-water-seo-root')) {
    window.postMessage(
      {
        message: 'open_new_tab_lead_url',
        value: { url: url }
      },
      '*'
    );
  } else {
    window.open(url, '_blank');
  }
};

export const getParameterByName = (email: string) => {
  var match = RegExp('[?&]' + email + '=([^&]*)').exec(window.location.search);
  return match && decodeURIComponent(match[1]);
};

// Return host name
export const siteUrlFormat = (urlLink: string) => {
  try {
    const fullUrl = new URL(urlLink);
    let url = fullUrl.hostname + fullUrl.pathname;
    let lastChart = url.slice(-1);
    if (lastChart === '/') {
      url = url.slice(0, -1);
    }

    return url;
  } catch (error) {
    return urlLink;
  }
};

// Get client reference id
export const getClientReferenceId = () => {

  let affiliateCode = 'checkout_' + new Date().getTime();

  if (getCookie(AFFILIATE_COOKIE_NAME)) {
    affiliateCode = getCookie(SEO_AFFILIATE_COOKIE_NAME);
  }

  return affiliateCode
};

// Decode JWT token
export const decodeJWT = async (token) => {
  const tokenDetail = await decryptEncryptedJWT(token);
  // const tokenDetail = jwt_decode(token);
  return tokenDetail;
};

// Set,remove,get local storage
export const localStorageMethod = (method, localName, setValue: any = '') => {
  try {
    if (typeof localStorage === 'undefined') {
      console.warn('localStorage is not available.');
      return;
    }
    switch (method) {
      case 'set':
        if (localName && setValue !== undefined && setValue !== null) {
          localStorage.setItem(localName, setValue);
        } else {
          console.warn(
            'Invalid parameters for "set" method. Ensure localName and setValue are valid.'
          );
        }
        break;
      case 'get':
        if (localName) {
          return localStorage.getItem(localName);
        } else {
          console.warn(
            'Invalid parameter for "get" method. Ensure localName is valid.'
          );
          return null;
        }
      case 'remove':
        if (localName) {
          localStorage.removeItem(localName);
        } else {
          console.warn(
            'Invalid parameter for "remove" method. Ensure localName is valid.'
          );
        }
        break;
      default:
        console.warn(`Unknown method: ${method}`);
        break;
    }
  } catch (error) {
    console.warn('localStorage access denied or error occurred:', error);
    return null;
  }
};

const getExpTime = () => {
  const d = new Date();
  d.setTime(d.getTime() + 60 * 24 * 60 * 60 * 1000);
  return d.toUTCString();
};

// Get GSC URL
export const getRequestGscUrl = () => {
  return localStorage.getItem('GSCRequestURL');
};

/**
 * Get GSC Text update
 *
 * @param textMessage for passed string
 * @param IndexedTutorial for pass tutorial url
 * @param requestGSCUrl for page url
 *
 * @returns
 */
export const updateGSCText = (
  textMessage: string,
  IndexedTutorial: string,
  requestGSCUrl: string
): string => {
  // Ensure all inputs are valid strings, fallback to empty string if not
  if (!textMessage || typeof textMessage !== 'string') return '';
  const tutorialUrl =
    typeof IndexedTutorial === 'string' ? IndexedTutorial : '';
  const websiteUrl = typeof requestGSCUrl === 'string' ? requestGSCUrl : '';

  return textMessage
    .replace(
      /watch our tutorial/g,
      `<a class="watch_tutorial" href='${tutorialUrl}' target="_blank">watch our tutorial</a>`
    )
    .replace(
      /watch this tutorial/g,
      `<a class="watch_tutorial" href='${tutorialUrl}' target="_blank">watch this tutorial</a>`
    )
    .replace(
      /[(]+Website URL+[)]/g,
      `<a class="watch_tutorial" href='${websiteUrl}' target="_blank">${websiteUrl}</a>`
    );
};

// When click on support and tutorials at that time open widget
export const handleInterComClick = () => {
  const widget: any = document.querySelector('.intercom-launcher');
  if (widget) {
    widget.click();
  }
  if (widget == null) {
    const iframeWidget: any = document.querySelector(
      '.intercom-launcher-frame'
    ) as HTMLIFrameElement;
    const launchElement = iframeWidget?.contentDocument?.querySelector(
      '.intercom-launcher'
    ) as HTMLElement;
    if (launchElement) {
      launchElement.click();
    }
  }
};

export const getIsSubscription = () => {
  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  return !stripeSubscriptionDetails
    ? null
    : stripeSubscriptionDetails['subscription_id'] !== undefined
    ? true
    : false;
};

/**
 * Check valid URL
 *
 * @param url The URL to check
 *
 * @returns boolean indicating if the URL is valid
 */
export const checkValidURL = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Remove localStorage value
 */
export const removeSquareSpaceToken = () => {
  localStorage.removeItem('squareSpaceAuthEmail');
  localStorage.removeItem('squareSpaceAuthName');
  localStorage.removeItem('squareSpaceTeamSize');
  localStorage.removeItem('squareSpaceYourRole');
  localStorage.removeItem('squareSpaceOther');
};

/**
 * Set setSquareSpace Token value
 */
export const setSquareSpaceToken = (name, email) => {
  if (name) {
    localStorage.setItem('squareSpaceAuthName', name);
  }
  if (email) {
    localStorage.setItem('squareSpaceAuthEmail', email);
  }
};

export const firstWordCapital = (string: String) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Refreshes and updates the details of the currently selected site's audit status.
 */
export const refreshSelectedSitesDetails = async (event) => {
  let selectedSiteAuditDetails: any =
    store.getState().siteAudit.siteAuditDetails;

  try {
    // Retrieve the currently selected site ID directly from the global Redux store state.
    // Why it works: This gives us the "intended" site ID even if the full 'siteAuditDetails' object hasn't been populated by the API yet.
    // Without this: If 'siteAuditDetails' is null (first load/refresh), we have no ID to compare against, forcing us to reject the stream event and leaving the UI stuck in "loading".
    const currentSiteId = store.getState().siteAudit.siteId;

    // Determine if the incoming stream event belongs to the current view.
    // We check if it matches the ID inside the details object OR the ID we just fetched from the store.
    // Why it works: This dual-check acts as a fail-safe. If 'selectedSiteAuditDetails' is empty, 'currentSiteId' validly identifies the event as relevant.
    // Without this: Small/fast scans often send stream events before the initial API call finishes. Without this check, those events are discarded, and the user sees 0 progress or stale data.
    const isMatchingSite =
      selectedSiteAuditDetails?._id === event._id ||
      currentSiteId === event._id;

    if (!isMatchingSite || event?.total_scan_sub_pages == 0) {
      if (event?.total_scan_sub_pages == 0 && isMatchingSite) {
        const updatedDetails = {
          ...selectedSiteAuditDetails,
          // Explicitly set the _id in the state object from the event data.
          // Why it works: This "bootstraps" the local state with the correct ID.
          // Without this: Future checks that rely on 'selectedSiteAuditDetails._id' would fail if the initial object was empty, effectively breaking the update chain.
          _id: event._id,
          scan: {
            ...selectedSiteAuditDetails?.scan,
            completedProgressCount: 0
          }
        };
        store.dispatch(setSiteAuditDetails(updatedDetails));
      }
      return;
    }
    if (
      selectedSiteAuditDetails?._id === event._id &&
      event?.total_scan_sub_pages == 0 &&
      selectedSiteAuditDetails?.sites_audit == true
    ) {
      return;
    }
    let updatedScanCount = {
      completedProgressCount: event?.total_scan_sub_pages,
      processing: event?.total_scan_sub_pages === event?.total_sub_pages,
      progressCount: event?.total_sub_pages,
      totalCount: event?.total_sub_pages
    };

    const selectedSiteDetails = {
      ...selectedSiteAuditDetails,
      // Ensure the _id is always carried forward in the update.
      // Why it works: Keeps the Redux state consistent and self-validating for subsequent updates.
      // Without this: We might lose the linkage to the ID if 'selectedSiteAuditDetails' was originally a default/empty structure.
      _id: event._id,
      scan: updatedScanCount
    };
    store.dispatch(setSiteAuditDetails(selectedSiteDetails));
    if (updatedScanCount.processing) {
      store.dispatch(setSiteStatus(false));
    }
  } catch (error) {
    // Handle any errors
  }
};

export const getPremiumDetails = (Object, titleToMatch) => {
  if (Object) {
    for (const item of Object) {
      if (item.title === titleToMatch) {
        return item.value;
      }
    }
  }
  return '-';
};

export const getNormalizedPlan = (name, planDetails) => {
  if (!name) return name;
  const lowerName = name.toLowerCase();
  if (lowerName === Plans.Expert) return planDetails?.agency;
  if (lowerName === 'expertplus' || lowerName === 'expert plus' || lowerName === Plans.ExpertPlus?.toLowerCase()) return planDetails?.expertPlus;
  if (lowerName === Plans.Pro) return planDetails?.designer;
  if (lowerName === 'proplus' || lowerName === 'pro plus' || lowerName === Plans.ProPlus?.toLowerCase()) return planDetails?.proPlus || 'proplus';
  if (lowerName === Plans.Starter) return planDetails?.diy;
  if (lowerName === Plans.StarterPlus?.toLowerCase() || lowerName === 'starterplus' || lowerName === 'starter plus') return planDetails?.starterPlus || 'starterplus';
  if (lowerName === Plans.DIY) return planDetails?.diy;
  if (lowerName === Plans.LocalSEO) return planDetails?.localseo;
  if (lowerName === Plans.Free) return planDetails?.free;
  return lowerName;
};

export const planButtonLabelText = (activePlanName, planName, isMonth) => {
  let planDetails = store.getState().user.planDetails;
  activePlanName = getNormalizedPlan(activePlanName, planDetails);
  planName = getNormalizedPlan(planName, planDetails);

  let buttonName = 'Subscribe';
  // Free Plan
  if (activePlanName?.toLowerCase() == planDetails?.free) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Upgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Upgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Upgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Diy Plan
  if (activePlanName?.toLowerCase() == planDetails?.diy) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Upgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Starter Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.starterPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Designer Plan
  if (activePlanName?.toLowerCase() == planDetails?.designer) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Pro Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.proPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Agency Plan
  if (activePlanName?.toLowerCase() == planDetails?.agency) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Downgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Expert Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.expertPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Downgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Downgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Downgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Local Seo plan
  if (activePlanName?.toLowerCase() == planDetails?.localseo) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Upgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Upgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Upgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Upgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  return buttonName;
};

export const changePlanButtonText = (
  activePlanName,
  planName,
  isMonth,
  isTrailEnd = true
) => {
  let planDetails = store.getState().user.planDetails;
  activePlanName = getNormalizedPlan(activePlanName, planDetails);
  planName = getNormalizedPlan(planName, planDetails);

  let activeSubscription = store.getState().user.subscription;
  let freePlanLabel =
    activeSubscription?.allow_trial === true && isTrailEnd
      ? 'Free 7-day trial'
      : 'Upgrade';
  let buttonName = 'Subscribe';
  // Free Plan
  if (activePlanName?.toLowerCase() == planDetails?.free) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.diy:
          buttonName = freePlanLabel;
          break;
        case planDetails?.starterPlus:
          buttonName = freePlanLabel;
          break;
        case planDetails?.designer:
          buttonName = freePlanLabel;
          break;
        case planDetails?.proPlus:
          buttonName = freePlanLabel;
          break;
        case planDetails?.agency:
          buttonName = freePlanLabel;
          break;
        case planDetails?.expertPlus:
          buttonName = freePlanLabel;
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.diy:
          buttonName = freePlanLabel;
          break;
        case planDetails?.starterPlus:
          buttonName = freePlanLabel;
          break;
        case planDetails?.designer:
          buttonName = freePlanLabel;
          break;
        case planDetails?.proPlus:
          buttonName = freePlanLabel;
          break;
        case planDetails?.agency:
          buttonName = freePlanLabel;
          break;
        case planDetails?.expertPlus:
          buttonName = freePlanLabel;
          break;
      }
    }
  }
  // Diy Plan
  if (activePlanName?.toLowerCase() == planDetails?.diy) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Starter Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.starterPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.designer:
          buttonName = 'Upgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Designer Plan
  if (activePlanName?.toLowerCase() == planDetails?.designer) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.proPlus:
          buttonName = 'Upgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Pro Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.proPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.agency:
          buttonName = 'Upgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Agency Plan
  if (activePlanName?.toLowerCase() == planDetails?.agency) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Switch to Monthly';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Switch to Annual';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Upgrade';
          break;
      }
    }
  }
  // Expert Plus Plan
  if (activePlanName?.toLowerCase() == planDetails?.expertPlus) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Downgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Switch to Monthly';
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = 'Downgrade';
          break;
        case planDetails?.diy:
          buttonName = 'Downgrade';
          break;
        case planDetails?.starterPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.designer:
          buttonName = 'Downgrade';
          break;
        case planDetails?.proPlus:
          buttonName = 'Downgrade';
          break;
        case planDetails?.agency:
          buttonName = 'Downgrade';
          break;
        case planDetails?.expertPlus:
          buttonName = 'Switch to Annual';
          break;
      }
    }
  }
  // Local Seo Plan
  // Diy Plan
  if (activePlanName?.toLowerCase() == planDetails?.localseo) {
    if (isMonth == 'month') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.diy:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.starterPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.designer:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.proPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.agency:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.expertPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
      }
    }
    if (isMonth == 'year') {
      switch (planName?.toLowerCase()) {
        case planDetails?.free:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.diy:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.starterPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.designer:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.proPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.agency:
          buttonName = localSeoUpgradeCTAText;
          break;
        case planDetails?.expertPlus:
          buttonName = localSeoUpgradeCTAText;
          break;
      }
    }
  }
  return buttonName;
};

export const getWindowInnerHight = (value: number = 116) => {
  return window.innerHeight - value;
};

/**
 * Logs out the user by performing necessary cleanup actions.
 *
 * This function clears session-related data, including cookies,
 * local storage, and cached responses. It ensures that no cached
 * content is used after logout.
 *
 * @async
 * @function logoutFromApp
 * @returns {Promise<void>} A promise that resolves when logout actions are complete.
 */
let isLoggingOut = false;

export const logoutFromApp = async () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  try {
    posthogService.track(PostHogEvent.AUTH_USER_LOGGED_OUT);
    posthogService.reset();
    
    // Call the logout API to invalidate the session on the server
    await getLogout();
    removeCookie();
    delete axios.defaults.headers.common.Authorization;
    // Remove the Squarespace UTM cookie
    removeUtmCookie(squareSpaceUtm);

    // Remove the login or signup UTM cookie
    removeUtmCookie(isLoginOrSignup);

    removeUtmCookie(localseoSignup);
    removeUtmCookie(localseoSignupSqspFlow);
    removeUtmCookie(planNameCookie);

    // Remove other session-related cookies
    localStorageMethod('remove', 'from_login_sqsp');
    const clarityConsent = localStorage.getItem('clarityConsent');
    // Clear all data from local storage
    localStorage.clear();

    if (clarityConsent) {
      localStorage.setItem('clarityConsent', clarityConsent);
    }
  } catch (error) {
    console.error('Error during logout:', error);
  } finally {
    isLoggingOut = false;
  }
};

// clear cache code
// export const logoutFromApp = async () => {
//   try {
//     // Remove all caches
//     const cacheNames = await caches.keys();
//     await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));

//     // Remove cookies
//     removeCookie();
//     removeUtmCookie('squareSpaceUtm');

//     // Clear local storage
//     localStorage.clear();

//     // Perform the logout
//     await getLogout();
//   } catch (error) {
//     console.error('Error during logout:', error);
//   }
// };

export const setRequestGscURL = (url, isStore = false) => {
  if (!isStore) {
    let siteAuditDetails = store.getState().siteAudit.siteAuditDetails;
    localStorage.setItem('GSCRequestURL', siteAuditDetails['url']);
  }
  openNewTab(url);
};

export const priceTagRequestPayload = (data: any) => {
  return {
    value: data?.unit_amount / 100 || null,
    currency: data?.currency || null,
    items: [
      {
        item_id: data?.id || null,
        item_name: data?.metadata?.display_name || null,
        item_category: data?.interval == 'month' ? 'monthly' : 'annual',
        plan_option: data?.interval == 'month' ? 'monthly' : 'annual',
        price: data?.unit_amount / 100 || null,
        quantity: 1
      }
    ]
  };
};

export const sendInterComEvent = (payload: any) => {
  let interComData: any = {
    appID: INTERCOM_APP_ID,
    ...payload
  };
  new Intercom(interComData);
};

export const extractTextFromHTML = (html) => {
  // Create a new DOM element to use as a container
  const tempDiv = document.createElement('div');
  // Set its HTML to the provided string
  tempDiv.innerHTML = html;
  // Extract and return the text content
  return tempDiv.textContent || tempDiv.innerText || '';
};

export const setLastCountryStorage = (payload: any) => {
  localStorage.setItem('lastSelectedCountry', JSON.stringify(payload));
};

export const setKeywordResearchLastCountryStorage = (payload: any) => {
  localStorage.setItem(
    'keywordResearchLastSelectedCountry',
    JSON.stringify(payload)
  );
};

export const setKeywordResearchMenuStateStorage = (payload: any) => {
  localStorage.setItem('keywordResearchMenuState', JSON.stringify(payload));
};

export const setOtherToolMenuStateStorage = (payload: any) => {
  localStorage.setItem('otherToolMenuState', JSON.stringify(payload));
};

export const setOrbitAiMenuStateStorage = (payload: any) => {
  localStorage.setItem('orbitAiMenuState', JSON.stringify(payload));
};

export const getFirstName = (fullName) => {
  if (!fullName) return '';

  // Split the full name by spaces
  const parts = fullName.split(' ');

  // Map through each part and split by hyphen, taking the first part
  const cleanedParts = parts.map((part) => part.split('-')[0]);

  // Return the first of these cleaned parts
  return firstWordCapital(cleanedParts[0]);
};

export const getKeywordIcons = (fileName: string) => {
  return `/static/images/icons/keyword/${fileName}`;
};
/**
 * Create New account
 *
 * @param textMessage for passed string
 *
 * @returns
 */
export const createAccountLink = (textMessage: string) => {
  return textMessage;
};

/**
 * Formats a number with commas as thousands separators.
 * @param num - The number to be formatted, can be a number or a string.
 * @returns The formatted number as a string, or an empty string for invalid input.
 */
export const formatNumberWithCommas = (
  num: number | string | null | undefined
): string => {
  if (num === null || num === undefined) {
    return '';
  }

  // Convert the input to a string if it isn't already
  const numStr = typeof num === 'number' ? num?.toString() : num;

  // Check if the string is a valid number
  if (isNaN(Number(numStr))) {
    return '';
  }

  // Use a regular expression to add commas as thousands separators
  return numStr?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const setSiteAuditMenuStateStorage = (payload: any) => {
  localStorage.setItem('siteAuditMenuState', JSON.stringify(payload));
};

export const getSiteAuditIcons = (fileName: string) => {
  return `/static/images/icons/siteaudit/${fileName}`;
};

export const formatToUSCurrency = (num) => {
  // Check if the input is null
  if (num === null) {
    return ' ';
  }

  // Try to convert string to a number, if necessary
  const parsedNum = typeof num === 'string' ? parseFloat(num) : num;

  // Check if the parsed number is a valid number
  if (isNaN(parsedNum)) {
    return num; // Return the original value if it's not a valid number (e.g., 'abc11')
  }

  // Format the number if it's valid
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2
  }).format(parsedNum);
};

// Using a function declaration instead of a const arrow function
// because function declarations are hoisted. This prevents the
// "Cannot access before initialization" error that occurs when
// the function is called before its definition is evaluated.
export function isLocalSeoUser() {
  try {
    const state = store?.getState() || null;
    const user: any = state?.counter?.userDetails || null;
    const isLocalSeo = user?.isLocalSeo || null;
    return isLocalSeo;
  } catch (error) {
    return null;
  }
}

/**
 * Removes http, https, and www. from a URL string.
 *
 * @param url - The input URL
 * @returns The cleaned URL without protocol and www
 * @throws Error if the input is not a string or is empty
 */
export const removeHttpAndWWW = (url: string): string => {
  try {
    if (!url || typeof url !== 'string') {
      return;
    }

    let formattedURL = url.trim();

    if (formattedURL?.length === 0) {
      return;
    }

    // Remove protocol (http:// or https://)
    formattedURL = formattedURL.replace(/^https?:\/\//i, '');

    // Remove leading www.
    formattedURL = formattedURL.replace(/^www\./i, '');

    // Remove trailing slashes
    formattedURL = formattedURL.replace(/\/+$/, '');

    return formattedURL;
  } catch (err) {
    console.error('removeHttpAndWWW error:', err);
    return url ?? ''; // fallback: return original or empty string
  }
};

export const decryptEncryptedJWT = async (token) => {
  try {
    const secret = new TextEncoder().encode(
      process.env.REACT_APP_JWT_SECRET_USER
    );
    const { payload } = await jwtDecrypt(token, secret);
    return payload;
  } catch (err) {
    // console.log('decryptEncryptedJWT error:', err);
    return null;
  }
};

/**
 * Prevents space input in text fields.
 * Wraps the register result from react-hook-form.
 *
 * @param registerResult - The result of calling register('name', options)
 * @param onChangeCallback - Optional callback to run after the value is updated
 * @returns The modified register props
 */
export const preventSpaceInput = (
  registerResult: any,
  onChangeCallback?: (val: string) => void
) => {
  try {
    const { onChange, ...rest } = registerResult;
    return {
      ...rest,
      onChange: (e: any) => {
        try {
          if (e?.target) {
            e.target.value = e.target.value.replace(/\s/g, '');
          }
          onChange(e);
          if (onChangeCallback && e?.target?.value !== undefined) {
            onChangeCallback(e.target.value);
          }
        } catch (error) {
          console.error('Error in preventSpaceInput:', error);
          onChange(e);
        }
      },
      onKeyDown: (e: any) => {
        if (e.key === ' ') e.preventDefault();
      }
    };
  } catch (error) {
    return '';
  }
};

export function isAiAddonLocked() {
  try {
    const searchesDetails: any =
      useSelector(
        (state: RootState) => state.keywordResearch.searchesDetails
      ) ?? {};
    let userDetails: any =
      useSelector((state: RootState) => state.counter.userDetails) ?? {};
    const isFreeUserWithAiAddon = userDetails?.isFreeUserWithAiAddon || false;
    const isUnlocked =
      (searchesDetails?.totalAiSlots && searchesDetails?.totalAiSlots !== 0) ||
      isFreeUserWithAiAddon ||
      false;
    return !isUnlocked;
  } catch (error) {
    return false;
  }
}


/**
 * Formats a numeric value into a compact, localized string representation (e.g., "1.5K", "2.3M").
 * Falls back to 0 if the provided value is not a finite number.
 *
 * @param {number} [number=0] - The numeric value to be formatted.
 * @returns {string} The compactly formatted number string.
 */
export const formatCompactNumber = (number: number = 0): string => {
  let value = Number(number);

  if (!Number.isFinite(value)) {
    value = 0;
  }

  return new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 2,
  }).format(value);
};


export const removeAffiliateCoolie = () => {
    let hostName = window.location.host.split(`.`).slice(-2).join(`.`)

      if(hostName.includes('localhost')){
        hostName = 'localhost'
      }
    document.cookie = `${AFFILIATE_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${hostName}`;
}

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));